import {BalanceEffect, PaymentStatus, TransactionType} from "@/constants/PaymentConstants";
import {TaxObligationLedgerRecordDTO} from "@/dto/tax/TaxObligationDTO";

export function isValidAssessmentAmount(amount: unknown): amount is number {
    return typeof amount === 'number' && Number.isSafeInteger(amount) && amount >= 0;
}

export function canEditAssessment(record: TaxObligationLedgerRecordDTO): boolean {
    return record.paymentId == null && [TransactionType.LIABILITY, TransactionType.PENALTY_ASSESSMENT].includes(record.transactionType);
}

const countedPaymentStatuses = new Set([
    PaymentStatus.DRAFT, PaymentStatus.APPROVED, PaymentStatus.EXPORTED, PaymentStatus.SCHEDULED,
    PaymentStatus.PENDING, PaymentStatus.PENDING_FOR_ACTION, PaymentStatus.SETTLED, PaymentStatus.COMPLETED,
]);

export function linkedPaymentTotal(
    ledger: TaxObligationLedgerRecordDTO[],
    assessment: TaxObligationLedgerRecordDTO,
    excludedPaymentId?: number,
): number {
    const paymentType = assessment.transactionType === TransactionType.PENALTY_ASSESSMENT
        ? TransactionType.PENALTY_PAYMENT
        : [TransactionType.LIABILITY, TransactionType.TAX_BILL_ASSESSMENT].includes(assessment.transactionType)
            ? TransactionType.OBLIGATION_PAYMENT : null;
    return ledger.filter(record => record.relatedRecordId === assessment.id
        && record.paymentId != null && record.paymentId !== excludedPaymentId
        && record.transactionType === paymentType && record.balanceEffect === BalanceEffect.DECREASE
        && record.paymentStatus != null && countedPaymentStatuses.has(record.paymentStatus))
        .reduce((total, record) => total + record.amountCents, 0);
}
